import { render, staticRenderFns } from "./LaboratoriesModuleComponent.vue?vue&type=template&id=e3f539b0&scoped=true"
import script from "./LaboratoriesModuleComponent.vue?vue&type=script&lang=js"
export * from "./LaboratoriesModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./LaboratoriesModuleComponent.vue?vue&type=style&index=0&id=e3f539b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f539b0",
  null
  
)

export default component.exports